export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export interface PasswordRequirement {
  test: (password: string) => boolean;
  message: string;
}

export const passwordRequirements: PasswordRequirement[] = [
  {
    test: (password: string) => password.length >= 8,
    message: 'Password must be at least 8 characters'
  },
  {
    test: (password: string) => /[a-z]/.test(password),
    message: 'Password must include at least one lowercase letter'
  },
  {
    test: (password: string) => /[A-Z]/.test(password),
    message: 'Password must include at least one uppercase letter'
  },
  {
    test: (password: string) => /[0-9]/.test(password),
    message: 'Password must include at least one digit'
  },
  {
    test: (password: string) => /[^a-zA-Z0-9]/.test(password),
    message: 'Password must include at least one non-alphanumeric character'
  }
];

export const validatePassword = (password: string): PasswordValidationResult => {
  const errors: string[] = [];
  
  passwordRequirements.forEach(requirement => {
    if (!requirement.test(password)) {
      errors.push(requirement.message);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const validatePasswordMatch = (password: string, confirmPassword: string): { isValid: boolean; error?: string } => {
  if (password !== confirmPassword) {
    return {
      isValid: false,
      error: 'Passwords do not match'
    };
  }
  return { isValid: true };
};